import { Component } from '@theme/component';

/**
 * @typedef {object} ProductCustomPropertyRefs
 * @property {HTMLInputElement | HTMLTextAreaElement} textInput
 * @property {HTMLElement} characterCount
 */

class ProductCustomProperty extends Component {
  connectedCallback() {
    super.connectedCallback?.();

    this.#bindInseam();
  }

  handleInput() {
    this.#updateCharacterCount();
  }

  #bindInseam() {
    const selector = this.querySelector('[data-inseam-selector]');
    if (!selector) return;

    const input = selector.querySelector('[data-inseam-input]');
    const buttons = selector.querySelectorAll('[data-inseam-btn]');

    if (!input || !buttons.length) return;

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        buttons.forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');

        input.value = btn.dataset.value + '"';

        console.log('[Inseam]', input.value);
      });
    });
  }

  #updateCharacterCount() {
    const { characterCount, textInput } = this.refs;
    if (!characterCount || !textInput) return;

    const currentLength = textInput.value.length;
    const maxLength = textInput.maxLength;

    const template = characterCount.getAttribute('data-template');
    if (!template) return;

    characterCount.textContent = template
      .replace('[current]', currentLength)
      .replace('[max]', maxLength);
  }
}

customElements.define(
  'product-custom-property-component',
  ProductCustomProperty
);
